/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 付帯商品契約情報
 */
export interface Sgkb981aReqFtiGoodsDto {
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 適用開始日付：日付(yyyyMMdd)
     */
    applyStartDate?: string;
    /**
     * 満了予定年月：日付(yyyyMM)
     */
    expireScheduleyearmonth?: string;
    /**
     * 継続年数：数字
     */
    duration?: string;
}

